var _rect, _rect2, _rect3, _path, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 300.522,
    style: {
      fill: "#57A4FF"
    },
    width: 100.174,
    height: 33.391
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#57A4FF"
    },
    points: "434.087,100.174 434.087,33.391 400.696,33.391 400.696,100.174 300.522,100.174  300.522,33.391 267.13,33.391 267.13,100.174 189.217,100.174 189.217,211.478 0,211.478 0,512 356.174,512 356.174,445.217  512,445.217 512,100.174  "
  })), /*#__PURE__*/React.createElement("rect", {
    y: 211.478,
    style: {
      fill: "#83C9FF"
    },
    width: 356.174,
    height: 300.522
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100.174,
    y: 278.261,
    width: 33.391,
    height: 66.783
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 222.609,
    y: 278.261,
    width: 33.391,
    height: 66.783
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 133.565,
    y: 345.043,
    width: 89.043,
    height: 33.391
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.087,100.174V33.391h-33.391v66.783H300.522V33.391H267.13v66.783h-77.913v111.304H0V512h356.174v-66.783H512V100.174 H434.087z M322.783,478.609H33.391V244.87h289.391V478.609z M478.609,411.826H356.174V211.478H222.609v-77.913h256V411.826z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 300.522,
    width: 100.174,
    height: 33.391
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.7e8ac31f2833277f95cac92faefdba0a.svg";
export { ForwardRef as ReactComponent };